module.exports = __webpack_public_path__ + "static/media/DesktopRe-Corrigendum.9d99f041.pdf";